/* eslint-disable complexity */
/* eslint-disable max-statements */
/**
 * Parse info_idp cookie and extract customer data
 * This cookie is set by node-proxy cart endpoint with SameSite=None; Secure
 * and contains shopper authentication information for custom domains
 *
 * @param {Object} req - Request object (server-side) or undefined (client-side)
 * @returns {Object|null} Parsed customer data or null if invalid/missing
 */
function parseInfoCustIdpCookie(req) {
  let cookieValue;

  // Server-side (from req.cookies)
  if (req && req.cookies) {
    cookieValue = req.cookies.info_idp;
  } else if (typeof document !== 'undefined') {
    // Client-side (from document.cookie)
    const cookies = document.cookie.split(';');
    const infoCookie = cookies.find(c => c.trim().startsWith('info_idp='));
    if (infoCookie) {
      cookieValue = infoCookie.split('=')[1];
    }
  }

  if (!cookieValue) {
    return null;
  }

  try {
    // Cookie might be URI encoded
    const decoded = decodeURIComponent(cookieValue);
    const data = JSON.parse(decoded);

    // Build display name
    let displayName = '';
    if (data.firstname) {
      displayName = data.lastname
        ? `${data.firstname} ${data.lastname}`.trim()
        : data.firstname;
    } else if (data.username) {
      displayName = data.username;
    }

    return {
      loggedIn: data.auth !== 'none',
      shopperId: data.info_shopperId,
      name: data.firstname || data.username,
      lastname: data.lastname,
      displayName,
      customerId: data.info_cid,
      privateLabelId: data.plid ? parseInt(data.plid, 10) : undefined,
      currency: data.currency,
      membershipLevel: data.mbr,
      authType: data.auth,
      customerType: data.ctype,
      username: data.username
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to parse info_idp cookie:', error);
    return null;
  }
}

module.exports = { parseInfoCustIdpCookie };

